<script>
import { QuestionCircleIcon } from '@thehotelsnetwork/icons/vue/linear';

import Loader from '@/components/Loader/Loader.vue';

export default {
  components: {
    QuestionCircleIcon,
    Loader,
  },
  props: {
    tpConfig: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({
        title: 'Error',
        text: 'There\'s been an error',
      }),
    },
    loading: Boolean,
  },
};
</script>

<template>
  <div>
    <div class="flex items-center">
      <div
        v-if="tpConfig.content"
        v-tooltip="tpConfig"
        class="w-5 h-5 ml-4"
      >
        <QuestionCircleIcon class="w-full h-full" />
      </div>
    </div>

    <div
      v-if="loading"
      class="h-56"
    >
      <Loader
        :size="'big'"
      />
    </div>

    <div
      v-else-if="error.show"
      class="my-20 text-center"
    >
      <p class="text-xl font-bold text-base-900">
        {{ error.title }}
      </p>

      <p class="text-base font-medium text-base-700">
        {{ error.text }}
      </p>
    </div>
  </div>
</template>
